import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import Row from '../tag/Row';
import Span from '../tag/Span';
import { FormattedMessage, injectIntl } from 'react-intl';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';
import WindowUtils from '../../utils/WindowUtils';
import { BIOBANK, USER } from '../../data/reducer';
import {
  doGetConsentStatus,
  doGetDocumentContent,
  doUpdateConsent,
  resetDocumentContent,
  updateBioBankAgreement,
} from '../../data/biobank/actions';
import Loader from '../Loader';
import PrintButton from './print/PrintButton';
import { Refusal } from './print/Refusal';
import { formatDate } from '../../utils/TimeUtils';
import {
  getRefusalPdfParagraphs,
  pdfCallback,
  printPdf
} from '../../utils/BioBankUtil';
import BioBankHeader from './BioBankHeader';

var moment = require('moment');
const { id: module_id } = module;

class BioBankRefusal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      refusal: false,
      validFrom: '',
    };
  }

  componentDidMount() {
    let { consentData, doGetDocumentContent } = this.props;

    if (consentData) {
      let version = this.hasActiveRefusal() ? consentData.version : null;

      doGetDocumentContent('refusal', 'REFUSAL', version);
    }

    if (!isEmpty(consentData) && consentData.status != null) {
      if (consentData.status === 'REFUSAL') {
        this.setState({ refusal: true });
      }
    }
    this.setState({clicked: false});
  }

  componentWillUnmount() {
    let { resetDocumentContent } = this.props;
    resetDocumentContent('refusal');
  }

  hasActiveRefusal() {
    return (
      this.props.consentData && this.props.consentData.status === 'REFUSAL'
    );
  }

  setRefusal = (val) => {
    this.setState({ refusal: val });
  };

  back = () => {
    WindowUtils.navigate('#/biobank/');
  };

  next = (version) => {
    let { userInfo, updateBioBankAgreement, doUpdateConsent } = this.props;

    let data = {
      consentType: 'OPT-IN',
      documentType: 'REFUSAL',
      language: 'FIN',
      version: version,
    };
    doUpdateConsent(data).then(() => {
      updateBioBankAgreement(true);
      WindowUtils.navigate('#/biobank/');
    });
  };

  mapDocumentContentComponents = () => {
    let {
      refusalDocumentContent: { data },
    } = this.props;

    if (!data) return null;

    return data.content.reduce((acc, cur) => {
      switch (cur.name) {
        case 'header':
          return {
            ...acc,
            header: cur,
          };
        case 'contentText':
          return {
            ...acc,
            contentText: cur,
          };
        default:
          throw 'Unknown component';
      }
    }, {});
  };

  getCorrectRefusalParagraphs = (documentContentComponents) => {

    if (this.props.consentData) {
      if (documentContentComponents.contentText.content.text.includes("<p>")) {
        const refusalParagraphs = getRefusalPdfParagraphs(documentContentComponents.contentText.content.text);
        return (
            <span className="radio-label">
              {refusalParagraphs.map((paragraph, index) => {
                return (
                    <>
                      {paragraph}
                      {index < refusalParagraphs.length - 1 &&
                        <>
                          <br />
                          <br />
                        </>
                      }
                    </>

                )
              })}
            </span>
        );
      } else {
        return (
            <span className="radio-label">
              {documentContentComponents.contentText.content.text}
            </span>
        )
      }
    }
  }

  renderForm() {
    let documentContentComponents = this.mapDocumentContentComponents();

    if (!documentContentComponents) return null;

    return (
      <>
        <h1>{documentContentComponents.header.content.text}</h1>

        <div className={'ot-form'}>
          <fieldset key={'refusal'}>
            <div className="radio-block">
              <label>
                <input
                  type="radio"
                  value={'agree'}
                  /*disabled={this.state.refusal}*/
                  checked={this.state.refusal === true}
                  onChange={() => this.setRefusal(true)}
                />
                <span className="radio-check" />
                {this.getCorrectRefusalParagraphs(documentContentComponents)}
              </label>
            </div>
          </fieldset>
        </div>
      </>
    );
  }

  printPdf = () => {
    let { consentData, intl } = this.props;
    printPdf(
      'Biopankki_kielto.pdf',
      'biopankkiPrintContainer',
      pdfCallback(
        {
          version: consentData.version,
          date: formatDate(consentData.versionApproved),
          type: 'refusal',
        },
        intl
      )
    );
  };

  allowSave() {
    let { clicked, refusal } = this.state;
    return refusal && !clicked;
  }


  render() {
    let {
      consentData,
      refusalDocumentContent: { status, data },
      userInfo,
    } = this.props;

    if (status === 'LOADING') return <Loader />;

    let hasActiveRefusal = this.hasActiveRefusal();

    let documentContentComponents = this.mapDocumentContentComponents();

    return (
      <div className="biobank">
        <div className="biobank_agreement_content_title">
          <BioBankHeader />
        </div>
        <div className="biobank_agreement_content_container biobank_agreement_content_container_part0">
          {hasActiveRefusal && (
            <span className="biobank_blue" style={{ float: 'right' }}>
              <FormattedMessage
                id={`${module_id}.refusal.done`}
                values={{
                  created: moment(consentData.validFrom).format('DD.MM.YYYY'),
                }}
              />
            </span>
          )}
          {this.renderForm()}
          <div style={{ marginTop: '10px' }}>
          </div>
          <Row>
            <Span len={6}>
              <OTButtonGroup type={'big'} expectedCount={2} collapseOnMobile>
                <OTButton
                  className="ot-button--gray"
                  key="submit"
                  onClick={this.back}
                >
                  <FormattedMessage id={`back`} />
                </OTButton>
                {!hasActiveRefusal && (
                  <OTButton
                    className="ot-button--light"
                    key="readmore"
                    onClick={() => {
                      this.setState({ clicked: true });
                      this.next(data.documentVersion)
                    }}
                    disabled={!this.allowSave()}
                  >
                    <FormattedMessage id={`confirm`} />
                  </OTButton>
                )}
              </OTButtonGroup>
            </Span>
            <Span len={6}>
              {hasActiveRefusal && (
                <div style={{ float: 'right' }}>
                  <PrintButton onClick={this.printPdf} />
                </div>
              )}
            </Span>
          </Row>
          {hasActiveRefusal && documentContentComponents && (
            <div style={{ display: 'none' }}>
              <Refusal
                version={consentData.version}
                headerText={documentContentComponents.header.content.text}
                contentText={documentContentComponents.contentText.content.text}
                date={formatDate(consentData.validFrom)}
                wholeName={userInfo.data.wholeName}
                hetu={userInfo.data.hetu}
                address={userInfo.data.address}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    refusalDocumentContent: state[BIOBANK].refusalDocumentContent,
    consentData: state[BIOBANK].consentData.data,
    userInfo: state[USER].userInfo,
    relatives: state[USER].relatives,
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    doGetDocumentContent,
    resetDocumentContent,
    doUpdateConsent,
    doGetConsentStatus,
    updateBioBankAgreement,
  })(BioBankRefusal)
);
